const cards = [
  {
    title: '治愈系日剧精选',
    desc: '温暖人心的十部高分治愈日剧，适合在疲惫的夜晚慢慢品味。',
    tag: '治愈',
    img: 'https://readdy.ai/api/search-image?query=Warm%20and%20peaceful%20Japanese%20style%20room%20with%20soft%20natural%20light%20streaming%20through%20window%2C%20cozy%20minimalist%20interior%2C%20gentle%20coral%20and%20amber%20color%20tones%2C%20calm%20atmosphere%2C%20editorial%20lifestyle%20photography%2C%20shallow%20depth%20of%20field%2C%20clean%20composition&width=600&height=360&seq=cards-img-01&orientation=landscape',
  },
  {
    title: '高分韩剧：口碑炸裂',
    desc: '近年豆瓣8.5分以上的韩剧盘点，部部精彩不容错过。',
    tag: '高分',
    img: 'https://readdy.ai/api/search-image?query=Modern%20Korean%20drama%20style%20scene%20with%20warm%20romantic%20lighting%2C%20urban%20cityscape%20background%20at%20sunset%2C%20cinematic%20composition%2C%20coral%20and%20amber%20color%20grading%2C%20professional%20film%20photography%20aesthetic%2C%20emotional%20atmosphere&width=600&height=360&seq=cards-img-02&orientation=landscape',
  },
  {
    title: '动作大片：燃爆肾上腺素',
    desc: '从好莱坞到亚洲，精选年度最值得看的动作电影合集。',
    tag: '动作',
    img: 'https://readdy.ai/api/search-image?query=Dynamic%20action%20movie%20scene%20with%20dramatic%20explosion%20and%20silhouette%20figure%2C%20intense%20warm%20orange%20and%20coral%20lighting%2C%20cinematic%20widescreen%20composition%2C%20Hollywood%20blockbuster%20aesthetic%2C%20dust%20and%20debris%20particles%20in%20air%2C%20professional%20film%20photography&width=600&height=360&seq=cards-img-03&orientation=landscape',
  },
  {
    title: '小众文艺片发现',
    desc: '那些被忽略的宝藏电影，每一部都值得被看见和记住。',
    tag: '文艺',
    img: 'https://readdy.ai/api/search-image?query=Artistic%20film%20projector%20with%20warm%20light%20beam%20in%20dark%20vintage%20room%2C%20nostalgic%20atmosphere%2C%20film%20reels%20and%20old%20movie%20posters%20on%20wall%2C%20coral%20and%20amber%20warm%20tones%2C%20professional%20photography%20with%20shallow%20depth%20of%20field%2C%20indie%20cinema%20aesthetic&width=600&height=360&seq=cards-img-04&orientation=landscape',
  },
  {
    title: '亲子动画：全家一起看',
    desc: '适合全家观看的高质量动画电影推荐，温馨又欢乐。',
    tag: '亲子',
    img: 'https://readdy.ai/api/search-image?query=Colorful%20animated%20movie%20scene%20with%20cute%20characters%20in%20bright%20warm%20environment%2C%20family-friendly%20atmosphere%2C%20soft%20coral%20and%20amber%20color%20palette%2C%20playful%20composition%2C%20modern%203D%20animation%20style%2C%20cheerful%20and%20inviting%20visual&width=600&height=360&seq=cards-img-05&orientation=landscape',
  },
];

export default function CardsSection() {
  return (
    <section id="cards" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-secondary-100 text-secondary-700 text-xs font-medium mb-4">
            <i className="ri-thumb-up-line"></i>
            <span className="whitespace-nowrap">编辑力荐</span>
          </div>
          <h2 className="text-2xl md:text-3xl font-bold text-foreground-950">热门推荐</h2>
          <p className="mt-2 text-sm text-foreground-500">精心挑选的优质内容，总有一部适合你</p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {cards.slice(0, 3).map((card) => (
            <div
              key={card.title}
              className="group rounded-xl overflow-hidden bg-background-50 border border-background-200/60 hover:border-primary-200/60 transition-all cursor-pointer"
            >
              <div className="relative w-full aspect-[16/10] overflow-hidden">
                <img
                  src={card.img}
                  alt={card.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                />
                <div className="absolute top-3 left-3">
                  <span className="text-[10px] px-2 py-0.5 rounded-full bg-primary-500/85 text-background-50 font-medium whitespace-nowrap">{card.tag}</span>
                </div>
              </div>
              <div className="p-4">
                <h3 className="text-sm font-semibold text-foreground-900 group-hover:text-primary-500 transition-colors">{card.title}</h3>
                <p className="text-xs text-foreground-500 mt-1.5">{card.desc}</p>
              </div>
            </div>
          ))}
          {cards.slice(3).map((card) => (
            <div
              key={card.title}
              className="group rounded-xl overflow-hidden bg-background-50 border border-background-200/60 hover:border-primary-200/60 transition-all cursor-pointer sm:col-span-2 lg:col-span-2"
            >
              <div className="flex flex-col sm:flex-row">
                <div className="relative w-full sm:w-[240px] aspect-[16/10] sm:aspect-auto sm:h-auto overflow-hidden flex-shrink-0">
                  <img
                    src={card.img}
                    alt={card.title}
                    className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                  />
                </div>
                <div className="p-4 flex-1">
                  <div className="flex items-center gap-2 mb-2">
                    <span className="text-[10px] px-2 py-0.5 rounded-full bg-accent-100 text-accent-700 font-medium whitespace-nowrap">{card.tag}</span>
                  </div>
                  <h3 className="text-sm font-semibold text-foreground-900 group-hover:text-primary-500 transition-colors">{card.title}</h3>
                  <p className="text-xs text-foreground-500 mt-1.5">{card.desc}</p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}